import { Grid, GridColumn, Icon, Separator } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { useContext, useEffect } from 'react';
import { RootStoreContext } from '../stores/RootStore';
const PersonInfoDetails = observer(() => {
    const { translateStore: { translate }, personInfoStore: { personInfo }, personInfoStore } = useContext(RootStoreContext);
    useEffect(() => {
        personInfoStore.loadPersonInfo();
    }, []);
    return (React.createElement(GridColumn, { width: ['xs-12', 'md-4', 'lg-3'], border: ['bottom-sm', 'bottom-xs', 'none-md', 'none-lg'] },
        React.createElement(Grid, { gutter: "none" },
            React.createElement(GridColumn, { width: ['xs-2', 'sm-1', 'md-12'] },
                React.createElement(Icon, { modifiers: "#contact", className: "h1" }),
                React.createElement(Separator, { color: "invisible", spacing: "xxsmall" })),
            React.createElement(GridColumn, { width: ['xs-10', 'sm-8', 'md-12'] },
                React.createElement(Grid, { gutter: "small" },
                    React.createElement(GridColumn, null,
                        React.createElement("p", { className: "text-light text-small" }, translate('personInfoDetails.name')),
                        React.createElement("p", null, (personInfo === null || personInfo === void 0 ? void 0 : personInfo.displayName) || '')),
                    React.createElement(GridColumn, null,
                        React.createElement("p", { className: "text-light text-small" }, translate('personInfoDetails.personalCode')),
                        React.createElement("p", null, (personInfo === null || personInfo === void 0 ? void 0 : personInfo.registrationNumber) || '')))))));
});
export default PersonInfoDetails;
